import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=243ecfb0"
import script from "./RoleDetail.vue?vue&type=script&lang=js"
export * from "./RoleDetail.vue?vue&type=script&lang=js"
import style0 from "./RoleDetail.vue?vue&type=style&index=0&id=243ecfb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports